module.exports = __webpack_public_path__ + "img/content-ylmf.b639d05f.png";